import { Component, OnInit, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, FormArray, Validators, UntypedFormBuilder } from '@angular/forms';

import { ApiAddress } from '../../api-client-module';
import { ProjectLanguage } from '../../firestore-models/project-language';

import { ConfigurationService } from '../../configuration.service';
import { TranslateService } from '@ngx-translate/core';

export interface MultiAddressDialogData {
  addresses?: ApiAddress[];
}

@Component({
  selector: 'app-multi-address-dialog',
  templateUrl: './multi-address-dialog.component.html',
  styleUrls: ['./multi-address-dialog.component.css'],
  standalone: false,
})
export class MultiAddressDialogComponent implements OnInit {

  //住所×言語数
  addresses: ApiAddress[] = [];
  addressesFormGroup!: FormGroup;
  addressesArrayControl!: FormArray;
  projectLanguages!: Array<ProjectLanguage>;

  currentLang: string = 'ja';
  projectBaseLang: string = 'ja';

  constructor(
    public dialogRef: MatDialogRef<MultiAddressDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MultiAddressDialogData,
    private formBuilder: UntypedFormBuilder,
    private configurationService: ConfigurationService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.projectLanguages = this.configurationService.getProject().languages!;
    this.addresses = this.data.addresses!;
    if (!this.addresses) {
      this.addresses = [];
    }
    this.createForm();
    this.addressesArrayControl = this.addressesFormGroup.get('addresses') as FormArray;
    this.currentLang = this.translate.currentLang;
    this.projectBaseLang = this.configurationService.getProject().project_base_lang!;

    //プロジェクト基本言語が管理画面の言語と異なる場合、編集不可にする
    if ((this.currentLang == 'en' && this.projectBaseLang == 'ja') || (this.currentLang == 'ja' && this.projectBaseLang != 'ja')) {
      this.addressesFormGroup.disable();
    }
  }

  //住所フォーム×言語数
  private createForm() {
    let arrayControl = this.formBuilder.array([]);
    let index: number = 0;
    let isAutoAllTrans: boolean = this.addresses.length > 0 ? true : false;
    for (const projectLanguage of this.projectLanguages) {
      let auto_trans = false;
      let address = '';
      let trans_address = '';
      for (const value of this.addresses) {
        if (projectLanguage.lang_code === value.lang_code) {
          if (!value.auto_trans && index !== 0) {
            isAutoAllTrans = false;
          }
          auto_trans = value.auto_trans ? value.auto_trans : false;
          address = value.address;
          trans_address = value.trans_address;
          break
        }
      }
      arrayControl.push(this.formBuilder.group(
        {
          autoTrans: [auto_trans],
          address: [address],
          transAddress: [trans_address],
        }
      ));
      index++;
    }
    this.addressesFormGroup = this.formBuilder.group(
      {
        autoAllTrans: [isAutoAllTrans],
        addresses: arrayControl
      }
    );
  }

  //更新ボタン
  addAddresses(): void {
    if (this.addressesFormGroup.valid) {
      let addresses = [];
      for (const index in this.projectLanguages) {
        const ctrl = this.addressesArrayControl.controls[index];
        addresses.push(
          {
            auto_trans: ctrl.get('autoTrans')!.value,
            lang_code: this.projectLanguages[index].lang_code,
            address: ctrl.get('address')!.value,
            trans_address: ctrl.get('transAddress')!.value,
          }
        )
      }
      this.addresses = addresses;
      this.dialogRef.close(this.addresses);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  //全言語自動翻訳
  onChangeAutoAllTrans(): void {
    const isAutoAllTrans = this.addressesFormGroup.get('autoAllTrans')!.value;
    for (const address of this.addressesArrayControl.controls) {
      address.get('autoTrans')!.setValue(isAutoAllTrans);
    }
    this.addressesArrayControl.controls[0].get('autoTrans')!.setValue(false);
  }

  //言語別自動翻訳
  onChangeAutoTrans(): void {
    let isAutoAllTrans: boolean = true;
    let index = 0;
    for (const address of this.addressesArrayControl.controls) {
      if (!address.get('autoTrans')!.value && index !== 0) {
        isAutoAllTrans = false;
        break;
      }
      index++
    }
    this.addressesFormGroup.get('autoAllTrans')!.setValue(isAutoAllTrans);
  }

}
